import React, { useState } from "react";
import PropTypes from 'prop-types';
import ReactDrawer from 'react-drawer';
import 'react-drawer/lib/react-drawer.css';
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions";

// Import menuDropdown
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import RightSidebar from "../CommonForBoth/RightSidebar";
import LightDark from "../CommonForBoth/Menus/LightDark";

// import images
import logoMain from "../../assets/images/logo/glogix-logo-dark.png";
import whitelogo from "../../assets/images/logo/glogix-logo-white.png";

//i18n
import { withTranslation } from "react-i18next";

const Header = props => {
  const { onChangeLayoutMode } = props;
  const [position, setPosition] = useState();
  const [open, setOpen] = useState(false);

  const toggleTopDrawer = () => {
    setPosition('right');
    setOpen(!open);
  };

  const onDrawerClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          {/* Left section: Toggle button + Brand logo */}
          <div className="d-flex align-items-center">
            <button
              type="button"
              className="nav-sidebar-toggle-btn d-lg-none"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}
              aria-label="Toggle Menu"
              title="Toggle Menu"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <line x1="9" y1="3" x2="9" y2="21" />
              </svg>
            </button>

            <Link to="/dashboard" className="nav-brand-link">
              <img
                src={props.layoutMode === "dark" ? whitelogo : logoMain}
                alt="Glogix"
                className="nav-brand-logo-img"
              />
            </Link>
          </div>

          {/* Right section: Theme Switcher Pill + User Profile */}
          <div className="d-flex align-items-center">
            <LightDark
              layoutMode={props.layoutMode}
              onChangeLayoutMode={onChangeLayoutMode}
            />
            <ProfileMenu />
          </div>
        </div>
      </header>

      <ReactDrawer
        open={open}
        position={position}
        onClose={onDrawerClose}
      >
        <RightSidebar onClose={onDrawerClose} onChangeLayoutMode={onChangeLayoutMode} />
      </ReactDrawer>
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
  layoutMode: PropTypes.any,
  onChangeLayoutMode: PropTypes.func,
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, layoutMode } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, layoutMode };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
